import { format, parseISO } from 'date-fns';
import { GetTodayFormattedDateProps } from 'interfaces/global.interfaces';
import { formatMexicoCityDate } from 'libs/mexicoCityDate';

// Formatea la fecha tal cual viene de la base de datos
export const formatDate = (date: string) => {
  const onlyDate = date.split('T')[0];
  const formattedDate = format(parseISO(onlyDate), 'dd/MM/yyyy');
  return formattedDate;
};

export const getTodayFormattedDate = ({
  format,
}: GetTodayFormattedDateProps) => {
  return formatMexicoCityDate(new Date(), format);
};

export const getTodayWeekdayName = () => {
  return formatMexicoCityDate(new Date(), 'EEEE');
};

export const getFormattedDate = (
  date: Date,
  format?:
    | 'yyyy-MM-dd'
    | 'dd-MM-yyyy'
    | 'yyyy/MM/dd'
    | 'dd/MM/yyyy'
    | 'dd/MMMM/yyyy'
) => {
  return formatMexicoCityDate(date, format ?? 'yyyy-MM-dd');
};
